import { createFileRoute } from "@tanstack/react-router";
import { JaziaShell } from "@/components/jazia/JaziaApp";
import { StatementPage, statementSearch } from "@/components/wallet/AccountDocs";
import { requireAuth } from "@/lib/require-auth";

export const Route = createFileRoute("/wallet_/statement")({
  validateSearch: statementSearch,
  beforeLoad: () => {
    requireAuth();
  },
  component: StatementRoute,
});

function StatementRoute() {
  const search = Route.useSearch();
  return (
    <JaziaShell page="wallet">
      <StatementPage initialFrom={search.from} initialTo={search.to} />
    </JaziaShell>
  );
}
